import { siteMeta, footerHrefs } from "../data/staticData";
import { useLanguage } from "../i18n/LanguageContext";
import { VisitorCounter } from "./VisitorCounter";

const LOGO_URL = "/assets/logo.png";

export function Footer() {
  const { t, language } = useLanguage();
  const legalHrefs = [`/privacy_${language}.html`, `/terms_${language}.html`, `/delete-account_${language}.html`];
  return (
    <footer className="relative bg-[#050505] border-t border-white/10 pt-16 pb-10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2">
              <img src={LOGO_URL} alt="NeuroScan" className="w-7 h-7 logo-neon" />
              <span className="font-display font-bold text-white">{siteMeta.name}</span>
            </div>
            <p className="mt-4 text-sm text-zinc-500 leading-relaxed max-w-xs">{t.site.description}</p>
          </div>

          <FooterCol
            title={t.footer.productTitle}
            labels={[t.nav.features, t.nav.reports, t.nav.pricing]}
            hrefs={footerHrefs.product}
            testid="footer-product"
          />
          <FooterCol
            title={t.footer.companyTitle}
            labels={[t.footer.aboutProduct, t.footer.contacts]}
            hrefs={footerHrefs.company}
            testid="footer-company"
          />
          <FooterCol
            title={t.footer.legalTitle}
            labels={[t.footer.privacyPolicy, t.footer.termsOfUse, t.footer.deleteAccount]}
            hrefs={legalHrefs}
            testid="footer-legal"
            external
          />
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4">
          <div className="text-xs text-zinc-600 font-mono-data space-y-1">
            <p>© {new Date().getFullYear()} TimAzSoft LLC · NeuroScan</p>
            <p>1021 E Lincolnway, 10374, Cheyenne, WY 82001, United States</p>
          </div>
          <div className="flex items-center gap-4">
            <VisitorCounter />
            <p className="text-xs text-zinc-600">{t.footer.rightsReserved}</p>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, labels, hrefs, testid, external = false }) {
  return (
    <div data-testid={testid}>
      <h4 className="font-mono-data text-xs text-zinc-500 uppercase mb-4">{title}</h4>
      <ul className="space-y-3">
        {labels.map((label, i) => (
          <li key={label}>
            <a
              href={hrefs[i]}
              {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
              className="text-sm text-zinc-400 hover:text-white transition-colors duration-200"
            >
              {label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
